import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>User Management</Typography>
      <p>When you create an account, you set yourself up as a single user with 
        access to Studio. You have privilages to manage the account (Administrator).
      </p>

      <p>This table lists all your users. Click on a username to view/edit that user account.</p>

      <Typography variant='h5' className='pb-5'>Add a user</Typography>

      <p>You can add other users to your account with access to Studio and/or Scan App.
        You can also choose to give a user administrator privilages. Click the [ADD USER]
        button at the top of the table to open the form.
      </p>

    </div>
  )
}

export default HelpText